;

console.log('starting logFilters.js');

;(() => {
  // console.log("NO FILTERING"); return;
  const orig = {};
  const counts = {};
  // Add patterns to drop (optional)
  const deny = [
    /.*:onnxruntime:.*/,
    // /^\[VAD\]/,
    // /\bCleanUnusedInitializersAndNodeArgs\b/,
  ];
  console.log('kaytek installed log filters like no-one has seen before', deny)

  const METHODS = [
    "log", "info", "warn", "error", "debug",
    "trace", "dir", "dirxml",
    "group", "groupCollapsed", "groupEnd",
    "table", "time", "timeEnd", "timeLog",
    "assert"
  ];

  for (const m of METHODS) {
    if (typeof console[m] === "function") {
      orig[m] = console[m].bind(console);
      counts[m] = 0;
    }
  }

  const toMsg = (args) => {
    try {
      return args.map(a => (typeof a === "string" ? a : JSON.stringify(a))).join(" ");
    } catch {
      return args.map(String).join(" ");
    }
  };

  const shouldDrop = (args) => deny.some(r => r.test(toMsg(args)));

  function wrap(method) {
    return (...args) => {
      counts[method]++;
      if (!shouldDrop(args)) {
        let serialized;
        try {
          serialized = JSON.stringify(args);
        } catch (e) {
          serialized = '[Circular object or unserializable data]';
        }
        orig[method](`${(new Date()).toLocaleString()} ${method}:`, serialized);
      }
    };
  }

  for (const m of Object.keys(orig)) {
    console[m] = wrap(m);
  }

  // Check anytime: __logCounts()
  // eslint-disable-next-line no-undef
  globalThis.__logCounts = () => ({...counts});

  // Emscripten stdout/stderr hook (if used)
  // eslint-disable-next-line no-undef
  const M = (globalThis.Module = globalThis.Module || {});
  M.print = (...a) => console.log(...a);
  M.printErr = (...a) => console.error(...a);
})();
